import { useEffect, useRef, useState } from "react";
import { useWfsService } from "../../../hooks";
import { WfsDeferredRequestResponse } from "../../../types/Wfs/WfsResponse";
import {
  DeferredRequestProgressResponse,
  DeferredRequestStatus,
} from "../../../types/Wfs/DeferredRequestProgressResponse";
import DeferredRequestNotStartedView from "./DeferredRequestNotStartedView";
import DeferredRequestFailedView from "./DeferredRequestFailedStartedView";
import DeferredRequestInProgressView from "./DeferredRequestInProgressView";
import DeferredRequestCompeteView from "./DeferredRequestCompeteView";

export interface DeferredRequestViewProps {
  deferredRequest: WfsDeferredRequestResponse;
  reset: () => void;
}

const DeferredRequestView = ({
  deferredRequest: { deferredRequestId },
  reset,
}: DeferredRequestViewProps) => {
  const clearIntervalRef = useRef<NodeJS.Timer>();
  const wfsService = useWfsService();
  const [deferredRequestProgress, setDeferredRequestProgress] =
    useState<DeferredRequestProgressResponse>({
      status: DeferredRequestStatus.NotStarted,
      progress: 0,
    });

  const pollDeferredRequest = () => {
    wfsService
      .PollDeferredRequest(deferredRequestId)
      .then((response) => {
        if (
          response.status === DeferredRequestStatus.Complete ||
          response.status === DeferredRequestStatus.Failed
        ) {
          clearInterval(clearIntervalRef.current);
        }
        setDeferredRequestProgress(response);
      })
      .catch(() => {});
  };

  const cancelPolling = () => {
    clearInterval(clearIntervalRef.current);
  };

  useEffect(() => {
    if (!deferredRequestId) return;
    clearIntervalRef.current = setInterval(pollDeferredRequest, 10000);
  }, [deferredRequestId]);

  return (
    <>
      {deferredRequestProgress.status === DeferredRequestStatus.NotStarted && (
        <DeferredRequestNotStartedView cancelPolling={cancelPolling} />
      )}
      {deferredRequestProgress.status === DeferredRequestStatus.Failed && (
        <DeferredRequestFailedView
          deferredRequestId={deferredRequestId}
          reset={reset}
        />
      )}
      {deferredRequestProgress.status === DeferredRequestStatus.InProgress && (
        <DeferredRequestInProgressView
          progress={deferredRequestProgress.progress}
          cancelPolling={cancelPolling}
        />
      )}
      {deferredRequestProgress.status === DeferredRequestStatus.Complete && (
        <DeferredRequestCompeteView
          downloadUrl={deferredRequestProgress.downloadUrl!}
        />
      )}
    </>
  );
};

export default DeferredRequestView;
